import { h } from 'preact'
import Header from '../header'
import Table from '../table/Table'
import ButtonControl from '../button-control/index'

export type EmailInfo = {
  type: string,
  title: string,
  description: string,
  subjectModule: 'Forum' | 'Control' | 'Common' | 'forum.mail.useractivation' | 'forum.mail.useractivated',
  subjectKey: string,
  subjectTranslation: string,
  bodyModule: 'Forum' | 'Control' | 'Common' | 'forum.mail.useractivation' | 'forum.mail.useractivated',
  bodyKey: string,
  bodyTranslation: string
}

interface Props {
  emailList: Array<EmailInfo>
}

const EmailTemplate = ({ emailList }: Props) => {
  const model = [{
    header: 'Template',
    accessor: 'title'
  },
  {
    header: 'Email trigger',
    accessor: 'description'
  },
  {
    header: 'Action',
    accessor: 'action'
  }]
  const rows = emailList.map((email: EmailInfo) => (
    {
      title: <div>{email.title}</div>,
      description: <div>{email.description}</div>,
      action: <a href={`/email/system-emails/edit?type=${email.type}`}>
        <ButtonControl title='Edit' variant='secondary' />
      </a>
    }
  ))
  return (
    <div className='email-templates-list'>
      <Header
        title='System Emails'
        disableSaveButton
        disableCancelButton
      />
      <Table model={model} rows={rows} narrow />
    </div>
  )
}

export default EmailTemplate
